<template>
  <div>
      <div style="width: 100%; text-align: right;" v-if="$store.state.tasks.group_task.length>0">
        <el-button @click="submitGroup" size="small" type="primary">
          Submit
        </el-button>
      </div>
      <div v-else style="width: 100%; text-align: center;">
        <el-button size="large" @click="$store.commit('addNewGroupTaskItemRow')" type="primary">
          Start Adding Tasks
        </el-button>
        
      </div>
    <el-table
            v-if="$store.state.tasks.group_task.length>0"
            :data="$store.state.tasks.group_task"
            style="width: 100%">
          
          <el-table-column 
            label="Title">
            <template slot-scope="scope">
              <el-input 
                  :id="'task_title_'+scope.row.key"
                  @focus="$event.target.select()"
                  v-model="scope.row.title"
                  size="small">
                </el-input>
            </template>
          </el-table-column>
          <el-table-column 
            label="Date/Time" width="250">
            <template slot-scope="scope">
              <el-date-picker
                    type="datetime"
                    v-model="scope.row.task_time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="MMM dd yyyy hh:mm a">
                </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column 
            label="Description">
            <template slot-scope="scope">
              <el-input 
                  @focus="$event.target.select()"
                  v-model="scope.row.description"
                  size="small">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column 
            label="Priority">
            <template slot-scope="scope">
              <el-select 
                  size="small"
                  v-model="scope.row.priority" filterable style="text-align: left;">
                  <el-option
                      :label="'Normal'"
                      :value="0">
                      <span style="float: left" v-html="'Normal'"></span>
                  </el-option>
                  <el-option
                      :label="'Medium'"
                      :value="1">
                      <span style="float: left" v-html="'Medium'"></span>
                  </el-option>
                  <el-option
                      :label="'Urgent'"
                      :value="2">
                      <span style="float: left" v-html="'Urgent'"></span>
                  </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column 
            label="Category">
            <template slot-scope="scope">
              <el-select 
                  size="small"
                  v-model="scope.row.category_id" filterable style="text-align: left;">
                  <el-option
                      v-for="(data, index) in $store.getters.getTaskCategoryList"
                      :key="index"
                      :label="data.category_name"
                      :value="data.id">
                      <span style="float: left" v-html="data.category_name"></span>
                  </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column 
            label="Assigned To">
               <template slot-scope="scope">
                 <el-select 
                    size="small"
                    v-model="scope.row.assigned_to_staff_id" 
                    filterable 
                    style="text-align: left;">
                    <el-option :value="0" label="Admin">
                        <span :style="'float: left;'" v-html="'Admin'"></span>
                    </el-option>
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active)"
                        :key="index"
                        :label="data.id === $store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name"
                        :value="data.id">
                        <span 
                            :style="'float: left; '+(data.id === $store.getters.getUserInformation.staff_id ? 'font-weight: bold; color: red;' : '')+''" 
                            v-html="data.id === $store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name"></span>
                    </el-option>
                </el-select>
               </template>
          </el-table-column>
          <el-table-column
                label=""
                width="120">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        
                        <el-tooltip class="item" effect="dark" content="Add">
                          <a v-if="scope.row.category_id >0 && scope.row.assigned_to_staff_id !== null && scope.row.title.length > 0" 
                            @click="$store.commit('addNewGroupTaskItemRow')" style="cursor: pointer; font-size: 16px;">
                            <i class="el-icon-circle-plus"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.commit('removeGroupTaskItemRow', scope.row.key)"
                              title="Are you sure to delete this?"
                              >
                                <a slot="reference" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
        
  </div>
</template>

<script>
export default {
  methods: {
    submitGroup() {
      this.$store.dispatch('submitGroupTasks', this.$store.state.tasks.group_task)
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Tasks/GroupTask.vue